import ContentWrapper from "../../../components/Add/ContentWrapper";
import Breadcrumbs from "../../../components/breadcrumbs/Breadcrumbs";
import { DynamicFilterConfig } from "../../../components/DynamicComponent/DynamicFilterPanel";
import BalanceSheetTable from "../../../components/GridTable/BalanceSheet";

export default function BalanceSheet() {
    const dynamicFilterConfig: DynamicFilterConfig = {
        "Date Range": {
            label: "Date",
            type: "date",
            required: false,
            searchKey: "date"
        },
    }
    return (
        <div>
            <Breadcrumbs
                navPath={["Zoodpay Money", "Balance Sheet"]}
                heading="Balance Sheet"
                noNavigation
                list={true}
            />
            <BalanceSheetTable
                staticText={{ emptyScreenText: { heading1: "No Data", heading2: "No records found." } }}
                mainEndPoint={"balance-sheet"}
                TableDetails={{}}
                handleActions={() => { }}
                filters={true}
                exporting={true}
                dynamicFilterConfig={dynamicFilterConfig}
                customHeight="h-balanceSheetFilterHeight"
            />
        </div>
    )
}
